import classNames from 'classnames';
import React, { ReactNode, VFC } from 'react';
import { useToggle } from 'react-use';

import TriangleRight from '@/icons/triangle-right.svg';

import styles from './CollapsableBox.module.scss';

type Props = {
  heading: string;
  children: ReactNode;
};

const CollapsableBox: VFC<Props> = ({ heading, children }: Props) => {
  const [isOpen, setIsOpen] = useToggle(false);

  return (
    <div className={styles.collapsableBox}>
      <button
        className={classNames(styles.header, { [styles.activeHeader]: isOpen })}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className={styles.headingContent}>
          <div className={styles.headingContentInner}>{heading}</div>
        </div>
        <TriangleRight
          className={classNames(styles.triangle, {
            [styles.activeTriangle]: isOpen,
          })}
        />
      </button>

      {isOpen && <div className={styles.content}>{children}</div>}
    </div>
  );
};

export default CollapsableBox;
